import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const NoticeStateWashington = forwardRef(({ data, company, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-2xl">
            <div ref={refToPrint} className="space-y-6 text-gray-900 text-base leading-relaxed w-full">
                <h2 className="text-2xl font-bold">
                    NOTICE REGARDING INVESTIGATIVE CONSUMER REPORTS PER WASHINGTON LAW
                </h2>

                <p>
                    In connection with your prospective or continued employment, {company?.name}, the "Company," may request an investigative
                    consumer report from a third-party consumer reporting agency, which may include information as to your character,
                    general reputation, personal characteristics or mode of living. An "investigative consumer report" is a background
                    report that includes information from personal interviews. The most common form of an investigative consumer report
                    in connection with your employment is a reference check through personal interviews with sources such as your former
                    employers and associates, and other information sources.
                </p>

                <p>
                    You may request in writing a complete and accurate disclosure of the nature and scope of any investigation procured.
                    You may also request a summary of your rights under the Washington Fair Credit Reporting Act.
                </p>

                <p>
                    The source of any investigative consumer report will be{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        VerifiedID
                    </a>
                    ,{" "}
                    <a href="tel:+18887182597" className="text-blue-600 underline">
                        (888) 718-2597
                    </a>
                    , 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA,{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://verifiedid.co
                    </a>
                    .
                </p>
            </div>
        </div>
    )

})

export default NoticeStateWashington
